module.exports = require('./dist/zepto');



//////////////////
// WEBPACK FOOTER
// ./~/@dp/zepto/index.js
// module id = 1
// module chunks = 0